module.exports = __webpack_public_path__ + "static/media/唯一（王力宏）.b6fa5443.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/music/唯一（王力宏）.mp3
// module id = 487
// module chunks = 0